import React from 'react';
export function Footer() {
  return <footer className="bg-brand-ink border-t border-white/10 py-14 px-5 text-center" data-id="element-28">
      <div className="max-w-4xl mx-auto" data-id="element-29">
        {/* Logo / Brand */}
        <div className="mb-6" data-id="element-30">
          <h4 className="text-brand-gold font-black text-2xl tracking-widest mb-1" data-id="element-31">
            El Gran Tesoro del Craft
          </h4>
          <p className="text-white/40 text-xs uppercase tracking-widest" data-id="element-32">
            Mega Bundle Maestro
          </p>
        </div>

        <p className="text-white/40 text-sm mb-8 max-w-xl mx-auto leading-relaxed" data-id="element-33">
          Porque crear algo hermoso no debería depender de tutoriales dispersos,
          materiales al azar y proyectos que nunca terminan.
        </p>

        {/* Final CTA */}
        <a href="#oferta" className="inline-flex items-center gap-2 bg-brand-gold hover:bg-brand-goldHover text-white font-bold px-8 py-3 rounded-xl transition-all hover:-translate-y-0.5 text-sm mb-10" data-id="element-34">
          Conseguir el bundle por $19.990 →
        </a>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-white/30 text-xs" data-id="element-35">
          <span data-id="element-36">
            &copy; {new Date().getFullYear()} El Gran Tesoro del Craft™. Todos
            los derechos reservados.
          </span>
          <div className="flex gap-6" data-id="element-37">
            <a href="#" className="hover:text-white/60 transition-colors" data-id="element-38">
              Términos
            </a>
            <a href="#" className="hover:text-white/60 transition-colors" data-id="element-39">
              Privacidad
            </a>
            <a href="#" className="hover:text-white/60 transition-colors" data-id="element-40">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}